export default "__VITE_ASSET__DGSZLsYY__"